export default __webpack_public_path__ + "static/media/0000..0007.c4b0cb27.png";